
import React from 'react'
import { MOVIE, AD, WEISCHER, HIGHLIGHT, ADVERTISEMENT } from '../constants/itemTypes'
import ItemMovieAccess from '../ItemsAccess/ItemMovieAccess'
import ItemAdAccess from '../ItemsAccess/ItemAdAccess'
import ItemWeischerAccess from '../ItemsAccess/ItemWeischerAccess'
import ItemAdvertisementAccess from '../ItemsAccess/ItemAdvertisementAccess'
import ItemHighlightAccess from '../ItemsAccess/ItemHighlightAccess'



const CollectionItemsAccess = ({
    htmlId,
    collectionId,
    filterType,
    filterValue,
    items
}) => {

    return (
        items.map(({id, type}) => {
            const itemHtmlId = `${htmlId}_${id}`

            return (
                MOVIE === type ? (
                    <ItemMovieAccess
                        key={itemHtmlId}
                        htmlId={itemHtmlId}
                        id={id}
                        filterType={filterType}
                        filterValue={filterValue}
                    />
                ) : HIGHLIGHT === type ? (
                    <ItemHighlightAccess
                        key={itemHtmlId}
                        htmlId={itemHtmlId}
                        id={id}
                    />
                ) : AD === type ? (
                    <ItemAdAccess
                        key={itemHtmlId}
                        htmlId={itemHtmlId}
                        id={id}
                    />

                // ) : WEISCHER === type ? ( //ToDo
                //     <ItemWeischerAccess
                //         key={itemHtmlId}
                //         htmlId={itemHtmlId}
                //         id={id}
                //         collectionId={collectionId}
                //     />

                ) : ADVERTISEMENT === type ? (
                    <ItemAdvertisementAccess
                        key={itemHtmlId}
                        htmlId={itemHtmlId}
                        id={id}
                        filterType={filterType}
                        filterValue={filterValue}
                    />
                ) : ''
            )
        })
    )

}

export default CollectionItemsAccess